import { Button } from "@/view/components/ui/button";

interface DocumentCardProps {
  image?: string;
  handleClick?: () => void;
  ref?: React.RefObject<HTMLInputElement>;
  icon: React.ReactNode;
  labelButton: string;
}

export const DocumentCard = ({ image, icon, labelButton, handleClick }: DocumentCardProps) => {
  return (
    <div className="border rounded-xl p-2 w-full flex flex-col gap-2">
      <div className="bg-gray-100 rounded-lg aspect-[2/1]  overflow-hidden">
        {image ? (
          <img src={image} alt="Document" className="w-full h-full object-cover" />
        ) : (
          <div className="w-full h-full flex items-center justify-center">
            {icon}
          </div>
        )}
      </div>

      <Button className="h-8 rounded-full text-xs text-white" onClick={handleClick}>
        {labelButton}
      </Button>

    </div>
  )
}